import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface Props {
  locationName: string;
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

const DisableWeatherConfirmationDialog = ({
  locationName,
  open,
  onSubmit,
  onClose,
}: Props) => {
  const handleSubmit = () => {
    onClose();
    onSubmit();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {`Delete weather history for ${locationName}?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {`All recorded weather history for ${locationName} will be deleted when this weather location is disabled.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color='secondary' variant='contained'>
            Go Back
          </Button>
          <Button
            onClick={handleSubmit}
            color='error'
            variant='contained'
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisableWeatherConfirmationDialog;
